import type { TableColumnsType } from 'antd';
import { DataTypeReportData } from 'store/ducks/Reportings/types';

export const columns: TableColumnsType<DataTypeReportData> = [
  {
    title: 'Name of the financial entity',
    width: 100,
    dataIndex: 'entity_name',
    key: 'entity_name',
    fixed: 'left',
  },
  {
    title: 'Data Description',
    width: 100,
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Location of data management',
    width: 100,
    dataIndex: 'location_of_data_management',
    key: 'location_of_data_management',
  },
  {
    title: 'Location of data at rest',
    width: 100,
    dataIndex: 'location_of_data_at_rest',
    key: 'location_of_data_at_rest',
  },
  {
    title: 'Sensitiveness of data stored by ICT TPSP',
    width: 100,
    dataIndex: 'sensitiveness_of_data_stored_by_ict_tpsp',
    key: 'sensitiveness_of_data_stored_by_ict_tpsp',
  },
  {
    title: 'ICT system',
    width: 100,
    dataIndex: 'ict_system_name',
    key: 'ict_system_name',
  },
];
